import _Promise from 'babel-runtime/core-js/promise';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';

import SearchBar from '@/components/SearchV3/index.vue';
import searchMixin from '@/mixin/search';
import deleteBtn from '@/components/DeleteBtn';
import previewModal from '@/components/PreviewModal';
import BasePackageTagManager from '@/components/BasePackageTagManager/index.vue';
import { fecthBasicList, updateBasicPackage as _updateBasicPackage, deleteBasic, detectBasic } from '@/api/material/basic';
import TagColumn from '@/components/TagColumn/index.vue';
import UpdatePackage from './update-package.vue';
import TableList from '@/components/TableList/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import _ from 'lodash';
import useValueExchangeLabel from '@/utils/useValueExchangeLabel';
import { sourceList, subSourceList } from '@/common/demand';
import { fmtSize, parseTime } from '@/filters';
import { v2Host } from '@/config/host';
import { getApiPath } from '@/common/api-proxy';
import { EngineType } from '@com/config/engine-type';
import { platform } from '@/common/platform';

export default {
  components: {
    SearchBar: SearchBar,
    deleteBtn: deleteBtn,
    previewModal: previewModal,
    BasePackageTagManager: BasePackageTagManager,
    TagColumn: TagColumn,
    UpdatePackage: UpdatePackage,
    TableList: TableList,
    Pagination: Pagination
  },

  mixins: [searchMixin],

  data: function data() {
    return {
      query: {
        platform: '',
        search_field: '',
        keyword: '',
        tag_ids: '',
        engine_types: '',
        page: 1,
        page_size: 15
      },
      pagination: {
        total: 0
      },
      platformOptions: [{
        value: 'ios',
        label: 'iOS'
      }, {
        value: 'android',
        label: 'Android'
      }],
      engineTypeOptions: EngineType,
      searchFieldOptions: [{
        value: 'id',
        label: '按ID'
      }, {
        value: 'app_name',
        label: '按名称'
      }, {
        value: 'username',
        label: '开发人员'
      }, {
        value: 'filename',
        label: '素材名称'
      }],
      list: [],
      listLoading: false,
      total: 1,
      dialog: {
        visible: false,
        loading: false,
        data: {
          id: '',
          zip_file: '',
          dm_dco_id: '',
          dm_tpl_id: '',
          setting: {
            isSupportDco: 2,
            isSupportStage: 0,
            stage: [],
            supported_mw_configs: []
          },
          material_source: '',
          provider_id: ''
        }
      },
      previewDialog: {
        visible: false,
        title: '',
        html_url: '',
        cn_html_url: '',
        showCnUrl: false,
        id: ''
      },
      creativeProvider: []
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.getList(_this.query);
              _context.next = 3;
              return _this.$store.dispatch('config/getCreativeProvider');

            case 3:
              _this.creativeProvider = _context.sent;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  computed: {
    tableConfig: function tableConfig() {
      return {};
    },
    tableColumnConfig: function tableColumnConfig() {
      var self = this;
      var list = [{
        label: 'ID',
        prop: 'id'
      }, {
        label: '图标',
        width: 70,
        prop: 'app_icon',
        type: 'image',
        params: {
          preview: true
        }
      }, {
        label: 'App名称',
        prop: 'app_name',
        params: {}
      }, {
        label: '缩略图',
        width: 100,
        prop: 'thumbnail',
        type: 'image',
        params: {
          preview: true
        }
      }, {
        label: '素材名称',
        width: 200,
        prop: 'filename',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            return '\u540D\u79F0: ' + row.filename + '<br />\u5927\u5C0F: ' + fmtSize(row.file_size) + '<br />\u7248\u672C: ' + row.version;
          }
        }
      }, {
        label: '素材信息',
        width: 200,
        prop: 'platform',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return '\u5E73\u53F0: ' + row.platform + '<br />\u5F15\u64CE: ' + self.engineType(row.engine_type) + (row.engine_type === 1 && row.ext_project_id ? ' (' + row.ext_project_id + ')' : '') + '<br />\u7814\u53D1: ' + row.developer.real_name + '<br />\u8BF4\u660E: ' + row.zip_comment;
          }
        }
      }, {
        label: '制作商/来源',
        prop: 'provider_id',
        params: {
          innerHTML: function innerHTML(_ref3) {
            var row = _ref3.row;

            var innerTemp = '\u5236\u4F5C\u5546: ' + useValueExchangeLabel(row.provider_id, self.creativeProvider) + '<br />\u6765\u6E90: ' + useValueExchangeLabel(row.material_source, sourceList);
            if (row.sub_material_source > 0) {
              innerTemp += '\uFF08' + useValueExchangeLabel(row.sub_material_source, subSourceList) + '\uFF09';
            }
            return innerTemp;
          }
        }
      }, {
        prop: 'tag-cell',
        slot: 'tag-cell'
      }, {
        label: '创建/更新时间',
        width: 150,
        prop: 'created_time',
        params: {
          innerHTML: function innerHTML(_ref4) {
            var row = _ref4.row;

            return parseTime(row.created_time) + '<br />' + parseTime(row.updated_time);
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
      return list;
    },
    formItemList: function formItemList() {
      return [{
        prop: 'material_source_ids',
        type: 'cascader',
        params: {
          clearable: false,
          props: {
            multiple: true,
            emitPath: false
          },
          placeholder: '请选择素材来源',
          options: sourceList.concat([{
            value: 4,
            label: 'PT/PS 制作'
          }]).map(function (item) {
            if ([1, 3].includes(item.value)) {
              return {
                value: item.value,
                label: item.label
              };
            }
            return {
              value: item.value,
              label: item.label,
              children: subSourceList.filter(function (subItem) {
                return subItem.parent === item.value;
              }).map(function (subItem) {
                return {
                  value: item.value + '-' + subItem.value,
                  label: subItem.label
                };
              })
            };
          })
        }
      },
      // 筛选供应商
      {
        prop: 'provider_ids',
        type: 'select',
        params: {
          clearable: false,
          multiple: true,
          placeholder: '请选择素材供应商',
          options: this.creativeProvider
        }
      }, {
        type: 'select',
        prop: 'platform',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入平台',
          options: platform
        }
      }, {
        type: 'select',
        prop: 'engine_types',
        params: {
          clearable: false,
          multiple: true,
          placeholder: '引擎类型',
          options: this.engineTypeOptions
        }
      }, {
        type: 'select',
        prop: 'search_field',
        params: {
          disabled: false,
          readonly: false,
          placeholder: '请输入搜索类型',
          options: this.searchFieldOptions
        }
      }, {
        type: 'input',
        prop: 'keyword',
        subtype: 'text',
        params: {
          clearable: true,
          placeholder: '请输入搜索关键字'
        }
      }];
    },
    singlePageDownloadURL: function singlePageDownloadURL() {
      return '' + v2Host + getApiPath('/material/basic/convert-single');
    }
  },

  watch: {
    $route: function $route(to, from) {
      this.getList(this.query);
    }
  },

  methods: {
    engineType: function engineType(v) {
      var idx = _.findIndex(this.engineTypeOptions, function (item) {
        return item.value === v;
      });
      return idx === -1 ? 'unknown' : this.engineTypeOptions[idx].label;
    },
    getList: function getList(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                _this2.listLoading = true;
                _context2.next = 4;
                return fecthBasicList(data);

              case 4:
                res = _context2.sent;

                _this2.listLoading = false;
                _this2.list = _.get(res, 'data.data.list');
                _this2.pagination.total = _.get(res, 'data.data.total');
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](0);

                console.log(_context2.t0);
                _this2.listLoading = false;

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[0, 10]]);
      }))();
    },
    fuUpdateClose: function fuUpdateClose(done) {
      if (this.dialog.loading) {
        return false;
      }
      return done();
    },
    fnShowUpdate: function fnShowUpdate(obj) {
      this.dialog.data.dm_dco_id = obj.dm_dco_id;
      this.dialog.data.dm_tpl_id = obj.dm_tpl_id;
      this.dialog.data.provider_id = obj.provider_id;
      this.dialog.data.material_source = obj.material_source;
      if (obj.setting) {
        var setting = JSON.parse(obj.setting);
        if (setting.stage) {
          setting.stage = setting.stage.split(',');
        } else {
          setting.isSupportStage = setting.isSupportStage || 0;
          setting.stage = [];
        }
        setting.supported_mw_configs = setting.supported_mw_configs ? setting.supported_mw_configs.split(',') : [];
        this.dialog.data.setting = setting;
      } else {
        this.dialog.data.setting = {
          isSupportDco: 2,
          isSupportStage: 0,
          stage: [],
          supported_mw_configs: [],
          install_return_action: ''
        };
      }
      this.dialog.data.id = obj.id;
      this.dialog.visible = true;
    },
    fnDelete: function fnDelete(obj) {
      var _this3 = this;

      this.listLoading = true;
      deleteBasic({
        id: obj.id
      }).then(function (res) {
        _this3.$message({
          message: '删除成功',
          type: 'success'
        });
        _this3.query.page = 1;
        _this3.getList(_this3.query);
      }).catch(function () {
        _this3.listLoading = false;
      });
    },
    previewPA: function previewPA(obj) {
      this.previewDialog.visible = true;
      this.previewDialog.title = obj.app_name;
      this.previewDialog.html_url = obj.html_url;
    },
    updateBasicPackage: function updateBasicPackage(data) {
      var _this4 = this;

      return new _Promise(function (resolve, reject) {
        _updateBasicPackage(data).then(function (res) {
          var msg = res.data && res.data.msg ? res.data.msg : '更新成功';
          _this4.$message({ message: msg, type: 'success' });
          _this4.query.page = 1;
          _this4.getList(_this4.query);
          resolve();
        }).catch(function (error) {
          var errorMsg = _.get(error, 'data.msg');
          _this4.$alert(errorMsg, '错误提示', {
            type: 'error',
            customClass: 'basic-package-error-message',
            dangerouslyUseHTMLString: true
          });
          reject();
        });
      });
    },
    convertTagIds: function convertTagIds(ids) {
      return ids.split(',').filter(function (id) {
        return id !== '';
      }).map(function (id) {
        return Number(id);
      }).filter(function (id) {
        return id !== 0;
      });
    },
    reDetect: function reDetect(obj) {
      var _this5 = this;

      this.listLoading = true;
      detectBasic({
        id: obj.id
      }).then(function (res) {
        _this5.$message({
          message: '重新检测成功',
          type: 'success'
        });
        _this5.query.page = 1;
        _this5.getList(_this5.query);
      }).catch(function () {
        _this5.listLoading = false;
      });
    }
  }
};